;document.addEventListener( 'DOMContentLoaded', () => {
	// ---- helpers to avoid scrollbar layout shifts ----
	function setScrollbarWidthVar() {
		const probe = document.createElement( 'div' );
		probe.style.cssText = 'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll;visibility:hidden;';
		document.body.appendChild( probe );
		const sbw = probe.offsetWidth - probe.clientWidth;
		document.body.removeChild( probe );
		document.documentElement.style.setProperty( '--sbw', sbw + 'px' );
	}

	function markScrollY( selector ) {
		const els = Array.from( document.querySelectorAll( selector ) );
		const update = el => el.classList.toggle( 'has-scroll-y', el.scrollHeight > el.clientHeight + 1 );
		const ro = new ResizeObserver( entries => entries.forEach( e => update( e.target ) ) );
		const mo = new MutationObserver( () => els.forEach( update ) );
		els.forEach( el => {
			update( el );
			ro.observe( el );
			mo.observe( el, { childList: true, subtree: true, characterData: true } );
		} );
		window.addEventListener( 'load', () => els.forEach( update ) );
	}

	// Sliding header
	const header = document.querySelector( '.site-header' );

	let headerShift = 0;               // 0 .. -headerHeight (px)
	let lastScrollY = window.scrollY;  // for direction

	function applyHeaderShift() {
		document.documentElement.style.setProperty( '--site-header-shift', `${headerShift}px` );
		// optional: expose visible height if you used it elsewhere
		const vis = getHeaderVisibleHeight();
		document.documentElement.style.setProperty( '--header-visible-h', `${vis}px` );
	}

	applyHeaderShift();

	function getHeaderVisibleHeight() {
		if ( !header ) return 0;
		const cs = getComputedStyle( header );
		if ( cs.position !== 'sticky' && cs.position !== 'fixed' ) return 0;
		const h = header.offsetHeight || 0;
		return Math.max( 0, Math.min( h, h + headerShift ) ); // headerShift is negative
	}

	setScrollbarWidthVar();
	window.addEventListener( 'resize', setScrollbarWidthVar );

	// ---- sticky logic (no-squish bottom lock) ----
	const container = document.querySelector( "[data-module='listing']:not(.without-sidebar)" );

	if ( !container ) return;

	const columns = container.querySelector( ':scope > .listing-content > .wp-block-columns' );
	const sidebarCol = columns?.querySelector( ':scope > .wp-block-column:first-child' );
	const mainCol = columns?.querySelector( ':scope > .wp-block-column:nth-child(2)' );
	if ( !columns || !sidebarCol || !mainCol ) return;

	// Use the sidebar top as the trigger to avoid the 'jump'
	const triggerEl = container.querySelector( '[data-sticky-trigger]' ) || sidebarCol;

	// Ensure there is an inner wrapper we can position independently
	let inner = sidebarCol.querySelector( '.js-sticky-inner' );
	if ( !inner ) {
		inner = document.createElement( 'div' );
		inner.className = 'js-sticky-inner';
		while ( sidebarCol.firstChild ) inner.appendChild( sidebarCol.firstChild );
		sidebarCol.appendChild( inner );
	}

	// apply scroll-detection to the scrollable node to avoid width shifts
	markScrollY( ':scope .js-sticky-inner' );

	const TOP_OFFSET = 10; // px
	let ticking = false;

	// NEW: remember the last height before bottom constraint kicks in
	let lastUnconstrainedH = null;
	let bottomLockActive = false;

	const getAbsTop = el => el.getBoundingClientRect().top + window.scrollY;
	const getAbsBottom = el => el.getBoundingClientRect().bottom + window.scrollY;

	function getTopOffset() {
		let topOffset = TOP_OFFSET;
		topOffset += getHeaderVisibleHeight();            // header visible portion
		topOffset += getStickyOffset( '.promo-banner-sticky' ); // promo under header
		topOffset += getStickyOffset( '#section-nav' );
		topOffset += getStickyOffset( 'nav.is-anchor-navigation' );
		topOffset += getStickyOffset( '#the-anchor-bar' );
		return topOffset;
	}

	function getStickyOffset( element ) {
		const el = typeof element === 'string'
				   ? document.querySelector( element )
				   : element;
		if ( !el ) return 0;
		const position = window.getComputedStyle( el ).position;
		return ( position === 'sticky' || position === 'fixed' )
			   ? el.offsetHeight
			   : 0;
	}

	function lockSidebarWidth() {
		const w = sidebarCol.getBoundingClientRect().width;
		sidebarCol.style.setProperty( '--sticky-width', `${w}px` );
	}

	// keep the column's layout height stable when the inner becomes fixed
	function lockSidebarPlaceholderHeight() {
		sidebarCol.style.setProperty( '--sticky-placeholder-h', `${inner.scrollHeight}px` );
	}

	function readPxVar( el, name, fallback = 0 ) {
		const raw = getComputedStyle( el ).getPropertyValue( name ).trim();
		const num = parseFloat( raw );
		return Number.isFinite( num )
			   ? num
			   : fallback;
	}

	function update() {
		ticking = false;

		const y = window.scrollY;
		const vh = window.innerHeight;
		const triggerY = getAbsTop( triggerEl );
		const lastCard = container.querySelector( '.product-list-container .card--other:last-child' );
		const lastMb = lastCard
					   ? readPxVar( lastCard, 'margin-bottom', 32 )
					   : 32;
		const containerB = getAbsBottom( container ) - lastMb;
		const topOffset = getTopOffset();

		// Visual top line of the sticky box (what the user sees)
		const visualTop = y + topOffset;

		// stick only while that visual top is inside the container
		const withinContainer = visualTop < containerB;
		const shouldStick = visualTop >= triggerY && withinContainer;

		const contentH = inner.scrollHeight;
		const minFixedH = Math.min( readPxVar( sidebarCol, '--sticky-fixed-min-h', 0 ), vh );

		// Viewport-only cap (ignore container bottom for this step)
		const viewportCap = Math.max( 0, vh - topOffset );
		const targetH = Math.min( contentH, Math.max( minFixedH, viewportCap ) );

		// Will the *unconstrained* target height cross the container bottom?
		const willHitBottom = ( y + topOffset + targetH ) > containerB;

		// Update/clear the bottom lock state
		if ( shouldStick ) {
			if ( !willHitBottom ) {
				// Remember the last healthy size (no bottom constraint yet)
				lastUnconstrainedH = targetH;
				bottomLockActive = false;
			} else {
				// We are at/past the bottom edge → lock height to the last healthy size
				if ( lastUnconstrainedH == null ) lastUnconstrainedH = targetH; // safety net
				bottomLockActive = true;
			}
		} else {
			// Not sticky → reset the lock
			lastUnconstrainedH = null;
			bottomLockActive = false;
		}

		// Decide the working height:
		// - Normal scrolling: use targetH (viewport-only)
		// - Bottom zone: freeze height to lastUnconstrainedH (but never exceed contentH)
		const frozenH = Math.min( contentH, lastUnconstrainedH ?? targetH );
		const desiredH = bottomLockActive
						 ? frozenH
						 : targetH;

		// Clamp the top so the fixed box stays inside the container with the desired height
		// Bound: y + top + desiredH <= containerB  =>  top <= containerB - y - desiredH
		let adjustedTop = Math.min( topOffset, containerB - y - desiredH );

		// Apply
		sidebarCol.classList.toggle( 'is-sticky', shouldStick );

		if ( shouldStick ) {
			lockSidebarWidth();
			lockSidebarPlaceholderHeight();
			sidebarCol.style.setProperty( '--sticky-top', `${adjustedTop}px` );
			sidebarCol.style.setProperty( '--sticky-max-h', `${desiredH}px` );
		} else {
			sidebarCol.style.removeProperty( '--sticky-max-h' );
			sidebarCol.style.removeProperty( '--sticky-top' );
		}

		inner.classList.toggle( 'has-scroll-y', inner.scrollHeight > inner.clientHeight + 1 );
	}

	function onScroll() {
		const y = window.scrollY;
		const delta = y - lastScrollY;
		lastScrollY = y;

		const topOffset = getTopOffset();
		const triggerY = getAbsTop( triggerEl );
		const containerBtm = getAbsBottom( container );

		const visualTop = y + topOffset;
		const beforeSticky = visualTop < triggerY;
		const inSticky = !beforeSticky && visualTop < containerBtm;
		const pastSticky = visualTop >= containerBtm;

		if ( header ) {
			if ( inSticky || pastSticky ) {
				const h = header.offsetHeight || 0;
				if ( delta > 0 ) {
					headerShift = Math.max( - h, headerShift - delta );
				} else if ( delta < 0 ) {
					headerShift = Math.min( 0, headerShift - delta );
				}
				applyHeaderShift();
			} else {
				if ( headerShift !== 0 ) {
					headerShift = 0;
					applyHeaderShift();
				}
			}
		}

		if ( !ticking ) {
			ticking = true;
			requestAnimationFrame( update );
		}
	}

	// Initial layout
	lockSidebarWidth();
	lockSidebarPlaceholderHeight();
	update();

	window.addEventListener( 'scroll', onScroll, { passive: true } );
	window.addEventListener( 'resize', () => {
		// On resize, recompute layout and clear the lock (viewport changed)
		lockSidebarWidth();
		lockSidebarPlaceholderHeight();

		lastUnconstrainedH = null;
		bottomLockActive = false;

		if ( header ) {
			const h = header.offsetHeight || 0;
			headerShift = Math.max( - h, Math.min( 0, headerShift ) );
			applyHeaderShift();
		}

		update();
	} );

	const ro = new ResizeObserver( () => {
		// Content size changed → recompute and clear lock if needed
		lockSidebarPlaceholderHeight();
		lastUnconstrainedH = null;
		bottomLockActive = false;
		update();
	} );
	ro.observe( inner );
	ro.observe( container );
} );
